import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconMyTripsProps } from './IconMyTrips.types'
import * as Styled from './styles/IconMyTrips.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMyTrips: FC<IconMyTripsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMyTripsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconMyTripsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <circle cx='63.8' cy='98.4' r='22.4' vectorEffect='non-scaling-stroke' />
          <circle cx='145.7' cy='46.6' r='12.3' vectorEffect='non-scaling-stroke' />
          <path d='M111.8 98.4c0 32-48 73.6-48 73.6s-48-41.6-48-73.6c0-26.5 21.5-48 48-48' vectorEffect='non-scaling-stroke' />
          <path
            d='M63.6 50.5c26.6 0 48.2 21.6 48.2 48.2M172 46.6c0 17.5-26.3 40.3-26.3 40.3s-26.3-22.8-26.3-40.3c0-14.5 11.8-26.3 26.3-26.3'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M145.6 20.3c14.6 0 26.4 11.8 26.4 26.4M64.8 172.1h52c68.1 0 61.4-38.2 30.4-47.8-26.9-8.4-17.9-34-1.4-37.4'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconMyTrips
